import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FilterHireExpertListings } from "../../../../redux/hire/action";
import { useAllFilterBaseContext } from "../../../../Context/AllFilterBaseContext";
import AllFilterPagination from "../../FindWork/FilterAll/AllFilterPagination";
import PostNotFound from "../../../CustomComponents/AllLoader/PostNotFound";
import { navigateToNextTab } from "../../../Common/FewCommonMethods";
import ProfilePic from "../../../../assests/imgs/Profileplaceholder.svg";
import Access from "../../../CustomComponents/Access/Access";
import { IS_LOGGED_IN_USER, decodeHtml } from "../../../../assests/extention/commonfunction";
import RoleBaseModel from "../../../CustomComponents/RoleBaseModel";
import RoleLabel from "../../../Common/RoleLabel";
import ProfileImageWithFallback from "../../../../common/ProfileImageWithFallback";
import CommonPagination from "../../../Common/PaginationComponet/CommonPagination";

const size = 9;

export default function HireExpertListings({ setTotalandsize }) {
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const { state, setPageNumber } = useAllFilterBaseContext();
  const { pageNumber } = state;
  const getallexpert = useSelector(({ hire: { getfilterdhiredexpert } }) => getfilterdhiredexpert);
  const getusesforhire = getallexpert?.experts || []
  const location = useLocation();
  const indcatsub = location?.state?.indcatsub;

  const data = {
    "method": "GET",
    "type": 5,
    index: pageNumber,
    "size": size,
    "industry_id": indcatsub?.industry_id,
    "category_id": indcatsub?.category_id,
    "subcategory_id": indcatsub?.subcategory_id,
    "filter": [
      {
        "id": "12",
        "title": "search Company / Expert",
        value: state?.search,
      },
      {
        "id": "13",
        "title": "Competencies",
        values: state?.specialities
      },
      {
        "id": "14",
        "title": "Location",
        values: state?.locationType

      },
      {
        "id": "15",
        "title": "Experience level",
        values: state?.experience

      },
      {
        "id": "16",
        "title": "Expert type",
        values: state?.expertType
      },
      {
        "id": "17",
        "title": "Hourly rates",
        "min": state?.minHourlyRate,
        "max": state?.maxHourlyRate
      },
      {
        "id": "18",
        "title": "Hiring type",
        values: state?.hiringType
      }
      ,
      {
        "id": "55",
        "title": "Sub-categories",
        values: state?.subcategories
      }
    ]
  }

  useEffect(() => {
    dispatch(FilterHireExpertListings(data));
  }, [state]);

  useEffect(() => {
    setTotalandsize({
      total: getallexpert?.count || 0,
      size: size || 0,
      index: pageNumber
    })
  }, [getallexpert])

  console.log(getusesforhire, 'item');


  return (
    <div>
      {modal ? (<Access modal={modal} setModal={setModal} state={"state"} />) : ("")}
      {Array.isArray(getusesforhire) &&
        getusesforhire.length > 0 ? (
        <div className="row exp-row">
          {Array.isArray(getusesforhire) &&
            getusesforhire?.map((item, index) => (
              <div className="col-lg-4 col-md-6">
                <div className="expert-details">
                  <ProfileImageWithFallback url={item?.profile_image} className="" />
                  <h4>
                    {decodeHtml(item?.first_name)} {decodeHtml(item?.last_name)}
                  </h4>
                  <h6>{decodeHtml(item?.designation)} </h6>
                  <h6>{<RoleLabel role_type={item?.role_type} />} </h6>
                  <div className="star">
                    <p>
                      <i className="fa-solid fa-star"></i> {item?.expert_rating || 0} (
                      {item?.expert_rating_count || 0} reviews)
                    </p>
                  </div>
                  <div className="skills">
                    {Array.isArray(item?.skills) &&
                      item?.skills
                        ?.slice(0, 5)
                        .map((item, index) => <p key={index}>{decodeHtml(item?.title)}</p>)}
                  </div>
                  <button
                    className="btn"
                    onClick={() => {
                      if (IS_LOGGED_IN_USER) {
                        localStorage.setItem('newTabState', JSON.stringify(indcatsub));
                        navigateToNextTab(`expertsprofiledetails/${item.id}`)
                      }
                      else {
                        setModal(true);
                      }
                    }}
                  >
                    See Profile
                  </button>
                </div>
              </div>
            ))}
          <CommonPagination
            totalitemcounts={getallexpert?.count}
            size={size}
            pageNumber={state?.pageNumber}
            setPageNumber={setPageNumber}
          />
        </div>
      ) : (
        <PostNotFound title={"Experts Not Found..."} />
      )}

    </div>
  );
}
